'use es6';

import { FilterFamilyAndButtonTooltipTranslator, FilterFamilyGroupHeadingTranslator, FilterFamilyNameTranslator, LegacyFilterFamilyObjectNameTranslator } from 'customer-data-filters/components/FilterFamilyTranslator';
import { Record } from 'immutable';
import emptyFunction from 'react-utils/emptyFunction';
import always from 'transmute/always';
import validateOperator from '../validateOperator';
import { Map as ImmutableMap } from 'immutable';
const DSFilterStrategyRecord = Record({
  onMount: emptyFunction,
  onEditorMount: emptyFunction,
  onUpdate: emptyFunction,
  getField: emptyFunction,
  getFieldDefinitions: emptyFunction,
  getFieldGroups: emptyFunction,
  getRefinementFieldGroups: emptyFunction,
  getFields: emptyFunction,
  getFilterFamilyAndButtonTooltip: filterFamily => FilterFamilyAndButtonTooltipTranslator(filterFamily),
  getFilterFamilyGroupHeading: filterFamily => FilterFamilyGroupHeadingTranslator(filterFamily),
  getFilterFamilyName: filterFamily => FilterFamilyNameTranslator(filterFamily),
  getFilterFamilyObjectName: filterFamily => LegacyFilterFamilyObjectNameTranslator(filterFamily),
  getFilterFamilyOptions: emptyFunction,
  getGroupedFilterFamilyOptions: emptyFunction,
  getOperatorsForType: emptyFunction,
  getListSegClassicOperatorsForType: emptyFunction,
  getReferenceResolvers: emptyFunction,
  getSpecialFieldOptions: emptyFunction,
  serializer: {
    toFormat: emptyFunction,
    fromFormat: emptyFunction
  },
  serializerOptions: {},
  getSerializerOptions() {
    return this.serializerOptions;
  },
  type: null,
  getUniqueFieldIdsByAssetFamily: emptyFunction,
  getObjectAssociationOptions: emptyFunction,
  validateOperator,
  isIncludeObjectsWithNoValueSetCheckboxEnabled: false,
  getIsFiscalYearEnabled: emptyFunction,
  getIsRollingDateOffsetInputEnabled: emptyFunction,
  getHasFilterFamilyAccess: always(true),
  getCustomFieldsForAssetFamily: always(ImmutableMap()),
  // customer-data-filters-ui only
  conditionsPerORGroupLimit: undefined,
  // customer-data-filters-ui only
  evaluateFiltersForObject: emptyFunction,
  // customer-data-filters-ui only
  isTestFiltersEnabled: false,
  // customer-data-filters-ui only
  isNotCompletedUnifiedEventFiltersEnabled: undefined // customer-data-filters-ui only
}, 'DSFilterStrategyRecord');
DSFilterStrategyRecord.fromJS = json => {
  if (json === null || json === undefined) {
    return json;
  }
  return DSFilterStrategyRecord(json);
};
DSFilterStrategyRecord.isDSFieldRecord = field => field instanceof DSFilterStrategyRecord;
DSFilterStrategyRecord.extend = (strategy, override) => {
  if (strategy && typeof strategy.merge === 'function') {
    return strategy.merge(override);
  }
  return undefined;
};
export default DSFilterStrategyRecord;